import React from 'react';
import MultiSort from 'multi-sort';
import brightnessColor from '~/src/lib/common/utils/brightnessColor';
import FontMc23 from '~/src/components/FontMc23';

function Social(props) {
    const { business } = props;

    if (typeof business === 'undefined') {
        return false;
    }

    if (Object.keys(business).length === 0) {
        return false;
    }

    if (!business.social) {
        return false;
    }

    if (business.social.length === 0) {
        return false;
    }

    MultiSort(business.social, {
        position: 'ASC',
    });

    //const bg = getCustomBg1(business);
    const brightnessByColor = brightnessColor(props.color);
    //const color = brightnessByColor < 122 ? '#FFFFFF' : '#000000';

    return (
        <div
            style={{
                margin: '0 auto',
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'row',
            }}
        >
            {business.social.map((social, index) => {
                if (typeof social.url !== 'string') {
                    return false;
                }

                if (social.url.length < 10) {
                    return false;
                }

                if (+social.active === 0) {
                    return false;
                }

                if (+social.active_footer === 0) {
                    return false;
                }

                let color = '#FFFFFF';

                if (brightnessByColor > 122) {
                    color = '#000000';
                }

                return (
                    <span key={social.id} style={{ marginRight: 15 }}>
                        <a
                            href={social.url}
                            target="_blank"
                            rel="noreferrer"
                            style={{ margin: 3, marginLeft: 5, marginRight: 5 }}
                        >
                            {/*
                            <FontMc23
                                simple={true}
                                code={social.unicode}
                                color={color}
                                size={25}
                            />
*/}

                            <div
                                style={{
                                    marginRight: 5,
                                    fill: color,
                                    //transform: 'scale(2)',
                                    width: 30,
                                }}
                                dangerouslySetInnerHTML={{
                                    __html: social.code,
                                }}
                            ></div>

                            {/*
                    <SvgComponent code={`${business.info.svgtest}`} styles="" />
                    */}
                        </a>
                    </span>
                );
            })}
        </div>
    );
}

export default Social;
